/*
 * FileName : news.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-07 16:11:35
 * Description :
 * -----
 * Last Modified: 2024-12-09 09:23:04
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

// eslint-disable-next-line no-use-before-define
import React, {useEffect } from 'react';
import { connect } from 'react-redux';
import { LangMessage } from 'src/store/common/language';
import { useHistory } from 'react-router-dom';
import { CloseOutlined, ExclamationCircleOutlined, UpOutlined } from '@ant-design/icons';
import { NEW_TOGGLE, NEWSITEM, NEWS_CLEAR, NEWS_COUNT_CLEAR, NEWS_REPLACE } from 'src/store/common/news';
import { message, Select, Button, Modal, BackTop, Drawer } from 'antd';
import { common } from 'src/api';
import useFetchState from 'src/utils/useFetchState';
import { MENUTABS_ADD } from 'src/store/common/menuTabs';
import { RoleObject } from 'src/utils/function';
import {isEqual, cloneDeep} from 'lodash';
const { Option } = Select;
const { confirm } = Modal;

type Props = {
    Mes: LangMessage;
    subSysNo: string;
    newsList: NEWSITEM[];
    dispatch: React.Dispatch<any>;
    newsShow: boolean;
    roleObj: RoleObject;
};

const News: React.FC<Props> = (props: Props) => {
    const { Mes, dispatch, subSysNo, newsList, newsShow, roleObj } = props;

    const history = useHistory();
    // 报警数量
    const [ alarmType, setAlarmType ] = useFetchState<string>('');
    const [ open, setOpen ] = useFetchState<boolean>(newsShow);
    const [ newsArr, setNewsArr ] = useFetchState<NEWSITEM[]>(newsList);

    // 右边消息弹出与关闭
    const newsClose = () => {
        dispatch({
            type: NEW_TOGGLE,
            value: false,
        });
        dispatch({
            type: NEWS_COUNT_CLEAR,
        });
        dispatch({
            type: NEWS_CLEAR,
        });
    };
    const onClose = () => {
        dispatch({
            type: NEW_TOGGLE,
            value: false,
        });
    };
    // 查看详情
    const lookAlarmDetails = (rows: NEWSITEM) => {
        if (rows.TYPE === 'Event') {
            history.push('/home/collectReport/deviceEvent', {
                subSysNo,
                Name: rows.DEVICE_NO,
                module: 'Device Event Query',
                deviceType: rows.ALARM_TYPE.includes('DCU') ? 'DCU' : 'Meter',
                startTime: rows.OCCUR_DATETIME,
                endTime: rows.OCCUR_DATETIME,
                EVENT_DESC: rows.EVENT_DESC,
                EVENT_ID: rows.EVENT_ID,
                dataStatus: rows.dataStatus,
            });
            dispatch({
                type: MENUTABS_ADD,
                value: {
                    key: 'Device Event Query',
                    title: 'menuTitleMeterAlarmEvent',
                    route: '/home/collectReport/deviceEvent',
                },
            });
        } else {// alarm
            history.push('/home/collectReport/deviceAlarm', {
                subSysNo,
                Name: rows.DEVICE_NO,
                module: 'Device Alarm Query',
                deviceType: rows.ALARM_TYPE.includes('DCU') ? 'DCU' : 'Meter',
            });
            dispatch({
                type: MENUTABS_ADD,
                value: {
                    key: 'Device Alarm Query',
                    title: 'menuTitleDcuAlarmEvent',
                    route: '/home/collectReport/deviceAlarm',
                },
            });
        }
    };
    // 报警更新
    const updateAlarm = async (rows: NEWSITEM) => {
        try {
            const res = await common.updateAlarmStatus({
                guid: rows.SN,
                alarmType: rows.ALARM_TYPE?.toLowerCase(),
                date: rows.OCCUR_DATETIME,
                type: rows.TYPE,
                dataStatus: rows.dataStatus?.toString(),
            });

            if (!res) {
                const newNewsList = cloneDeep(newsList);
                const newsFilter = newNewsList.filter((v) => v.SN !== rows.SN);

                dispatch({
                    type: NEWS_REPLACE,
                    value: newsFilter,
                });
                message.success(Mes['titleTableSuccesssuccess']);
            } else {
                message.error(res);
            }
        } catch (error) {
            console.error(error);
            message.error(typeof error === 'string' ? error : Mes['messageAlarmRequestfailrequestfail']);
        }
    };
    // 报警确认弹窗
    const updateStatusConfirm = async (rows: NEWSITEM) => {
        confirm({
            title: Mes['messageConfirmSureperformoperationsureperformoperation'],
            icon: <ExclamationCircleOutlined />,
            onOk () {
                updateAlarm(rows);
            },
        });
    };
    // 报警类型切换
    const selectChange = (value: string) => {
        if (!value) {
            setNewsArr(newsList);
        } {
            const lists = newsList.filter((v) => v.ALARM_TYPE.includes(value));

            setNewsArr(lists);
        }
        setAlarmType(value);
    };

    const getMoreAlerm = async () => {
        dispatch({
            type: MENUTABS_ADD,
            value: {
                key: 'Device Event Query',
                title: 'menuTitleMeterAlarmEvent',
                route: '/home/collectReport/deviceEvent',
            },
        });
        history.push('/home/collectReport/deviceEvent', {
            subSysNo,
            Name: '',
            module: 'Device Event Query',
            deviceType: '',
        });
    };

    useEffect(() => {
        setOpen(newsShow);
    }, [ newsShow ]);

    useEffect(() => {
        if (!isEqual(newsArr, newsList)) {
            const lists = newsList.filter((v) => v.ALARM_TYPE.includes(alarmType));

            setNewsArr(lists);
        }
    }, [ isEqual(newsArr, newsList) ]);

    return (
        <Drawer
            visible={open}
            closable={false}
            onClose={onClose}
            className='drawer-news'
            bodyStyle={{padding: '0'}}
            title={(
                <div className='flexCenter flexBetween'>
                    <div>
                        <span className='pr10'>{Mes['titleAlarmInformation']}</span>
                        <i className='count'>{ newsList.length }</i>
                    </div>
                    <div className='flex flexCenter'>
                        <Select defaultValue='' className='pr10' onChange={selectChange} value={alarmType} style={{width: '100px'}}>
                            <Option value=''>{ Mes['titleLabelComboallcomboall'] }</Option>
                            <Option value='Meter'>{ Mes['titleLabelMetermeter'] }</Option>
                            <Option value='DCU'>{ Mes['labelTitleGateway'] }</Option>
                        </Select>
                        <CloseOutlined onClick={() => newsClose()} />
                    </div>
                </div>
            )}
        >
            <div className='alarmList p6 scrollbar' id='alarmList'>
                <ul>
                    {
                        newsArr.map((v: NEWSITEM, i: number) => {
                            if (i >= 20) {return;}
                            return (
                                <li key={i}>
                                    <div className='top flexCenter flexBetween p6'>
                                        <span>{ Mes['titleTableXuhaoxuhao'] }{i + 1}</span>
                                        <div>
                                            <Button type='primary' onClick={() => updateStatusConfirm(v)}>{Mes['messageSuccessConfirmconfirm']}</Button>
                                            {
                                                (v.TYPE === 'Event' && roleObj['Device Event Query']) ||
                                                    (v.TYPE !== 'Event' && roleObj['Device Alarm Query'])
                                                    ? (<Button type='primary' onClick={() => lookAlarmDetails(v)}>{ Mes['labelTitleDetails'] }</Button>) : null
                                            }
                                        </div>
                                    </div>
                                    <div className='info p6'>
                                        <p>
                                            <span>{ Mes['labelTitleAlarmType'] }:</span>
                                            <span title={ v.TITLE }>{ v.TITLE }</span>
                                        </p>
                                        <p>
                                            <span>{ Mes['titleTableDevicenodeviceno'] }:</span>
                                            <span title={v.DEVICE_NO}> { v.DEVICE_NO } </span>
                                        </p>
                                        <p>
                                            <span>{ Mes['titleTableDeviceaddressdeviceaddress'] }:</span>
                                            <span title={v.DEVICE_ADDRESS}> { v.DEVICE_ADDRESS } </span>
                                        </p>
                                        <p>
                                            <span>{ Mes['titleTableOccurtimeoccurtime'] }:</span>
                                            <span title={v.OCCUR_DATETIME }>{ v.OCCUR_DATETIME }</span>
                                        </p>
                                        <p>
                                            <span>{ Mes['titleTableUpgradestatusupgradestatus'] }:</span>
                                            <span className='red'>{ Mes['comboboxUnconfirmedunconfirmed'] }</span>
                                        </p>
                                    </div>
                                </li>
                            );
                        })
                    }
                    {
                        newsList.length > 20 && roleObj['Device Event Query'] ? (
                            <div key='mli' style={{textAlign: 'center'}}>
                                <Button onClick={getMoreAlerm}>{ Mes['btnTitleLoadingMore'] }</Button>
                            </div>
                        ) : null
                    }
                    <BackTop target={() => document.getElementById('alarmList') as HTMLElement }>
                        <div className='up'>
                            <UpOutlined />
                        </div>
                    </BackTop>
                </ul>
            </div>
        </Drawer>
    );
};

export default connect((state: any) => ({
    Mes: state.langSwitch.message,
    subSysNo: state.userInfo.sysType,
    newsList: state.newsDispose.newsList,
    newsShow: state.toggleNews.newsShow,
    roleObj: state?.userInfo?.roleObj || {},
}))(News);
